import { emptyApi } from './emptyApi'
import { MemberCenterBase } from '../../types/centerTypes'
import { camelCaseResponse } from '../../shared/Functions'

export interface MembershipReportData extends MemberCenterBase {
  centerContacts: string[]
}

export const reportService = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getMembershipReport: builder.query<MembershipReportData[], void>({
      query: () => '/membership_report',
      transformResponse: (response: unknown): MembershipReportData[] => {
        return camelCaseResponse(
          response as Record<string, unknown>
        ) as MembershipReportData[]
      },
      providesTags: ['MemberCenter']
    })
  })
})

export const { useGetMembershipReportQuery } = reportService
